export const HAUFFE_LOGO = {
  src: "/brand/hauffe-logo-600.webp",
  srcSet: "/brand/hauffe-logo-420.webp 420w, /brand/hauffe-logo-600.webp 600w, /brand/hauffe-logo-900.webp 900w",
  sizes: "(max-width: 640px) 170px, 310px",
  width: 600,
  height: 212,
  altDe: "HAUFFE OS Logo",
  altEn: "HAUFFE OS logo"
} as const;

export const HAUFFE_SYMBOL = {
  src: "/brand/hauffe-favicon.svg",
  width: 512,
  height: 512,
  altDe: "HAUFFE OS Symbol",
  altEn: "HAUFFE OS symbol"
} as const;

export const APP_BRAND = {
  company: "HAUFFE",
  product: "HAUFFE OS",
  workspace: "Customer Value Workspace",
  subline: "Guided Digital Access"
} as const;
